import { useContext } from 'react'
import { Context } from '@/context'
import { ERoles, Employee } from '@/schemaTypes'

// Employee roles ordered from most to least privileged. Holding a role grants
// everything a lower role may do ("at least X"). Only hides UI — the API
// enforces the same hierarchy via @Permissions.
// Keep in sync with EMPLOYEE_ROLE_HIERARCHY in api/src/constants/general.ts.
export const EMPLOYEE_ROLE_HIERARCHY: readonly ERoles[] = [
  ERoles.Superadmin,
  ERoles.Admin,
  ERoles.Locationadmin,
  ERoles.Locationstaff,
  ERoles.Guest,
]

export const hasMinRole = (
  user: Pick<Employee, 'roles'> | null | undefined,
  minRole: ERoles,
): boolean => {
  const requiredIndex = EMPLOYEE_ROLE_HIERARCHY.indexOf(minRole)

  if (requiredIndex === -1 || !user?.roles?.length) {
    return false
  }

  return user.roles.some((role) => {
    const roleIndex = EMPLOYEE_ROLE_HIERARCHY.indexOf(role)
    return roleIndex !== -1 && roleIndex <= requiredIndex
  })
}

export const useHasMinRole = (minRole: ERoles): boolean => {
  const { getCurrentUser } = useContext(Context)
  return hasMinRole(getCurrentUser(), minRole)
}
